import { AxiosResponse } from 'axios';
import { Key } from 'react';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { OrgUnitReadDTO } from './dto';
import { GetManyPaged, GetManyUnpaged } from './types';

const RESOURCE_PATH = 'organic-units';

export const getOrgUnits: GetManyPaged<OrgUnitReadDTO> = async ({ filter, page, size, sort, config } = {}) =>
    client
        .get(buildPath([RESOURCE_PATH]), { ...config, params: { filter, page, size, sort } })
        .then((response: AxiosResponse) => response.data);

export const getOrgUnitRoots: GetManyUnpaged<{ ids: Key[] | undefined }, OrgUnitReadDTO> = async ({ ids, config }) =>
    client
        .get(buildPath([RESOURCE_PATH, 'roots']), { ...config, params: { ids } })
        .then((response: AxiosResponse) => response.data);

export const getOrgUnitChildren: GetManyUnpaged<{ code: string }, OrgUnitReadDTO> = async ({ code }) =>
    client.get(buildPath([RESOURCE_PATH, code, 'children'])).then((response: AxiosResponse) => response.data);
